import React from "react";
import TestReportsLayout from "../components/testreports/TestReportsLayout";

/** Reviewer's list of test reports to review. */
function ReviewerReports() {
  return <TestReportsLayout variant="reviewer" />;
}

export default ReviewerReports;
